
import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';


export default createVuetify({
  components,
  directives,
  defaults: {
    VTextField: { variant: 'underlined', color: 'primary' },
    VFileInput: { variant: 'underlined', color: 'primary' },
    VSelect: { variant: 'underlined', color: 'primary' },
    VBtn: { color: 'primary', rounded: 'lg', variant: 'outlined' },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#55c08b',
          secondary: '#a7cc48',
          accent: '#F1C40F',
          error: '#D0021B',
          info: '#2AB3BA',
          success: '#7ED321',
          warning: '#F5A623',
          clgraylight: '#c9c6bf',
          clblack: '#0f0f0f',
        },
        variables: {
          'hover-opacity': 0.04,
        },
      },
    },
  },
})
